import React from "react";
import Layout from "../Layout";
import WorkScheduleTable from "../../../shared/work-schedule/WorkScheduleTable";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

function WorkSchedule() {
  const { data: user, loading, error } = useFetchWithAuth("/user/me/");

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <Layout>
      <WorkScheduleTable
        title="Графік роботи"
        readOnly
        filterUserId={user?.id}
        dayOrder="asc"
      />
    </Layout>
  );
}

export default WorkSchedule;
